define('SuiteDynamics.CriteoCustomDataLayerFields.Utilities',
    [
        'SuiteDynamics.CriteoCustomDataLayerFields.Libraries.CryptoJS'
    ],
    function(
        CryptoJS
    )
{
    'use strict';

    function hashSHA256(str) {
        return str ? CryptoJS.SHA256(str.trim().toLowerCase()).toString(CryptoJS.enc.Hex) : '';
    }

    function hashMD5(str) {
        return str ? CryptoJS.MD5(str.trim().toLowerCase()).toString(CryptoJS.enc.Hex) : '';
    }

    return {
        hashSHA256: hashSHA256,
        hashMD5: hashMD5
    }
});
